module.exports = __webpack_public_path__ + "img/mobile-header.0402c653.png";